<template>
    <form @submit.prevent="handleSubmit">
        <div class="row mb-3 align-items-center">
            <div class="col-md-10">
                <label for="client" class="form-label">Cliente</label>
                <input type="text" id="client" class="form-control" style="text-transform: uppercase;"
                    v-model="formData.client" required />
            </div>

            <div class="col-md-2">
                <label for="color" class="form-label">Color</label>
                <input type="color" id="color" class="form-control form-control-color" v-model="formData.color" />
            </div>
        </div>

        <div class="mb-3">
            <label for="location" class="form-label">Locación</label>
            <input type="text" id="location" class="form-control" style="text-transform: uppercase;"
                v-model="formData.location" />
        </div>

        <div class="mb-3">
            <button type="submit" class="btn btn-warning w-100">Guardar</button>
        </div>
    </form>
</template>
<script setup>
import { ref } from "vue";
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const formData = ref({})

const handleSubmit = async () => {
    const body = { client: formData.value.client.toUpperCase() }
    try {
        const response = await axios.post(`${API_BASE_URL}/create-client`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status == 200) {
            alert('Cliente Creado')
            window.location.reload();
        }
    } catch (error) {
        console.error('Error al obtener los datos del usuario:', error);
    }
}

</script>
